function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCap({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 61 45",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "008---Cap",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m47 33.9c-.34.49-6.3 9-17 10-10.47.94-8.7-3.89-17.91-5.73-3-.6-8.28-1-10.72.54-.2770423.1775587-.62944879.1877662-.91630407.026541s-.46134472-.4675714-.45369593-.796541c0-.51.33-.7.75-1.08 2.17-2 6.75-4.76 11.25-8 .12 0 5.15-1 13 1 9.11 2.3 14.36 3.65 22 4.04z",
    fill: "#000000",
    "data-original": "#607d8b",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m47 33.9c-.34.49-6.3 9-17 10-1.3059992.1301785-2.6206355.1502493-3.93.06 7.06-.24 13.91-4.67 18-10.21 1.18.1 1.99.1 2.93.15z",
    fill: "#000000",
    "data-original": "#37474f",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m41.09 3.56c0 .21 0 .57-.09 1-.9775978-.31612448-1.9816403-.54370743-3-.68-1.09 0-3.08.21-3 .21l.09-.84c.36-3.25 6-2.89 6 .31z",
    fill: "#000000",
    "data-original": "#37474f",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m58.16 26.11c.0570896 1.899877-.0870464 3.8004613-.43 5.67-.1220663.9321074-.6347155 1.7683437-1.41 2.3-1.13709.4738431-2.3982089.5616648-3.59.25-2.45-.29-5-.4-6.92-.48-8.51-.34-19.58-4-24.75-4.76-2.9916488-.5313234-6.0469463-.6021415-9.06-.21.7-5.61 2.19-11.51 5.38-16.06 4.76-6.82 14.27-8.44 18.5-8.82 1.0930745-.20427615 2.2165711-.1804444 3.3.07 11.71 2.79 18.98 10.23 18.98 22.04z",
    fill: "#000000",
    "data-original": "#e91e63",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m58.16 26.11c.0570896 1.899877-.0870464 3.8004613-.43 5.67-.1220663.9321074-.6347155 1.7683437-1.41 2.3-1.13709.4738431-2.3982089.5616648-3.59.25 1.1079192-.3858227 1.8892812-1.3820593 2-2.55.6635735-3.816598.5786644-7.7258138-.25-11.51-1.79-7.59-7.2-12.41-14.48-15.08-.6114153-.51570082-1.282958-.95556128-2-1.31 3.8739121.66537162 7.5721297 2.11131688 10.87 4.25 6.31 4.11 9.29 10.43 9.29 17.98z",
    fill: "#000000",
    "data-original": "#ad1457",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m44.07 4.84c.35-4.66-7.44-5.41-8-.66-4.87.64-13.1 2.67-17.56 9.06-4.18 6-5.28 14.07-5.5 16.08-5.01 3.62-9.43 6.34-11.43 8.25-.66520416.639418-.7748644 1.6643195-.26 2.43.27012004.4168681.6949995.7091349 1.18089774.8123179.48589825.103183.99288423.0088027 1.40910226-.2623179.24-.16 2.53-1.5 8.45-.66 10.65 1.51 8.33 7 19.73 6 9.9-.9 15.87-8 17.39-10 1.89.09 3.74.21 5.6.45 1.2632918.2910206 2.588385.135543 3.75-.44 1.0091624-.6567219 1.6924122-1.7106711 1.88-2.9.3572275-1.9386088.5080693-3.9096083.45-5.88-.02-11.4-6.45-18.88-17.09-22.28zm-19.91 24.41c.6-5.07 3.47-20.86 15.67-23.31 9.28 5.23 4.77 23 3.47 27.47-7.58-1.1-15.15-3.41-19.14-4.16zm17.9-25c-1.2510938-.3935046-2.5786755-.47926569-3.87-.25.55-1.51 3.59-1.28 3.87.28zm-21.86 10.14c3.07-4.42 8.35-6.54 12.69-7.56-8 5.77-10.17 17.68-10.71 22.17-2.3186462-.3238558-4.6650958-.4009534-7-.23.34-2.77 1.57-9.44 5.02-14.38zm11.71 29.49c-10.56 1-8-4.39-19.27-6-4.94-.7-7.72 0-9 .55 2.16-1.81 6.36-4.43 10.75-7.6 9.33-1.4 20.17 4.22 32.61 5-3.816105 4.5135453-9.2159353 7.3941704-15.09 8.05zm26.84-11.31c-.41 1.94-1.43 2.09-3.41 1.83-4.37-.57-6.76-.39-10-.74 2.3-8 4-20.21-1.19-26.68 7.18 2.47 12.6 7 14.39 14.52.770948 3.643343.8422132 7.4000388.21 11.07z",
    fill: "#42629c",
    transform: "translate(-1 -1)",
    "data-original": "#000000",
    style: {},
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCap);
export default __webpack_public_path__ + "static/media/cap.debdb23c1c19ea431f870f1088c95990.svg";
export { ForwardRef as ReactComponent };